<template>
  <footer
    class="footer-bar bg-grey-lighten-4 border-t border-grey-lighten-2 py-3 pl-4"
    :style="footerStyle"
  >
    <v-container class="footer-content pa-0" :fluid="false">
      <div id="footer-prepend-content" class="footer-prepend"></div>
      <div class="footer-main">
        <span>
          <AppLink class="text-decoration-none text-primary" :to="URL_MAIN_WEBSITE">{{ $t('main_website_link_text') }}</AppLink>
          &nbsp;|&nbsp;
          <AppLink :to="URL_PRIVACY_POLICY" class="text-decoration-none text-primary">{{ $t('privacy_policy_title') }}</AppLink>
          &nbsp;|&nbsp;
          <a class="text-decoration-none text-primary" :href="URL_CC_BY_4" target="_blank" rel="noopener noreferrer">
            <v-icon>mdi-creative-commons</v-icon>
            {{ $t('site_license_name') }}
          </a>
        </span>
      </div>
    </v-container>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import useTheme from '@/composables/useTheme';
import {
  URL_CC_BY_4,
  URL_MAIN_WEBSITE,
  URL_PRIVACY_POLICY,
} from '@/constants/urls';
import AppLink from "@/components/common/AppLink.vue";
import { SIDEBAR_WIDTH } from '@/constants/layout';

const display = useDisplay();
const footerStyle = computed(() => {
  if (display.lgAndUp.value) {
    return {
      marginLeft: `${SIDEBAR_WIDTH}px`,
      width: `calc(100% - ${SIDEBAR_WIDTH}px)`
    };
  }
  return {
    marginLeft: 0,
    width: '100%'
  };
});
const { currentTheme } = useTheme();
</script>

<style scoped>
.footer-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
}
.footer-content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  font-size: 0.95rem;
  color: #6c757d;
}
.footer-prepend {
  width: 100%;
}
.footer-main {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.acknowledgement {
  flex: 1 1 60%;
  min-width: 200px;
}
</style>
